import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlSuggestResponse extends IIsiDtoPresentationLogicResponse  {
    data?: string;
    screenList?: string;
    screenListAvailable?: AvailableScreenList;
    hasOtherValues?: boolean;
}
export enum AvailableScreenList {
    NONE = 0,
    ONE = 1,
    SEVERAL = 2,
    NoneButSuggestNotUseProfilRights = 3,
    NOTDEFINED = -1,
}
export class IsiDtoPlSuggestResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlSuggestResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Suggest.IsiDtoPlSuggestResponse, Isilog.IsiComponent.IsiDataTransferObject";
    data?: string;
    screenList?: string;
    screenListAvailable?: AvailableScreenList;
    hasOtherValues?: boolean;

    constructor(data?: IIsiDtoPlSuggestResponse) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.screenList = _data["screenList"] !== undefined ? _data["screenList"] : <any>null;
            this.screenListAvailable = _data["screenListAvailable"] !== undefined ? _data["screenListAvailable"] : AvailableScreenList.NONE;
            this.hasOtherValues = _data["hasOtherValues"] !== undefined ? _data["hasOtherValues"] : false;
        }
    }

    static fromJS(data?: IIsiDtoPlSuggestResponse): IsiDtoPlSuggestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlSuggestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["screenList"] = this.screenList !== undefined ? this.screenList : <any>null;
        data["screenListAvailable"] = this.screenListAvailable !== undefined ? this.screenListAvailable : AvailableScreenList.NONE;
        data["hasOtherValues"] = this.hasOtherValues !== undefined ? this.hasOtherValues : false;
        return data;
    }
}
export interface IIsiDtoPlSuggestRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlSuggestResponse;
    ctrlType?: number;
    linkedCtrlFilter?: { [key: string]: string; };
    fieldValue?: string;
    actionType?: string;
    mainControlID?: string;
    callerType?: IsiCallerType;
    controlId?: string;
}
export enum IsiCallerType {
    None = 0,
    GreenArrow = 1,
    Suggest = 2,
}
export class IsiDtoPlSuggestRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlSuggestRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Suggest.IsiDtoPlSuggestRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlSuggestResponse;
    ctrlType?: number;
    linkedCtrlFilter?: { [key: string]: string; };
    fieldValue?: string;
    actionType?: string;
    mainControlID?: string;
    callerType?: IsiCallerType;
    controlId?: string;

    constructor(data?: IIsiDtoPlSuggestRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlSuggestResponse(data.response) : <IsiDtoPlSuggestResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlSuggestResponse.fromJS(_data["response"]) : <any>null;
            this.ctrlType = _data["ctrlType"] !== undefined ? _data["ctrlType"] : 0;
            this.linkedCtrlFilter = _data["linkedCtrlFilter"] !== undefined ? _data["linkedCtrlFilter"] : <any>null;
            this.fieldValue = _data["fieldValue"] !== undefined ? _data["fieldValue"] : <any>null;
            this.actionType = _data["actionType"] !== undefined ? _data["actionType"] : <any>null;
            this.mainControlID = _data["mainControlID"] !== undefined ? _data["mainControlID"] : <any>null;
            this.callerType = _data["callerType"] !== undefined ? _data["callerType"] : IsiCallerType.None;
            this.controlId = _data["controlId"] !== undefined ? _data["controlId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlSuggestRequest): IsiDtoPlSuggestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlSuggestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["ctrlType"] = this.ctrlType !== undefined ? this.ctrlType : 0;
        data["linkedCtrlFilter"] = this.linkedCtrlFilter !== undefined ? this.linkedCtrlFilter : <any>null;
        data["fieldValue"] = this.fieldValue !== undefined ? this.fieldValue : <any>null;
        data["actionType"] = this.actionType !== undefined ? this.actionType : <any>null;
        data["mainControlID"] = this.mainControlID !== undefined ? this.mainControlID : <any>null;
        data["callerType"] = this.callerType !== undefined ? this.callerType : IsiCallerType.None;
        data["controlId"] = this.controlId !== undefined ? this.controlId : <any>null;
        return data;
    }
}
